module.exports = __webpack_public_path__ + "img/LT302894776.068faf39.png";